import { render, staticRenderFns } from "./NewEventPage.vue?vue&type=template&id=c9dd772e&"
import script from "./NewEventPage.vue?vue&type=script&lang=js&"
export * from "./NewEventPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports